import React from 'react';
import clsx from 'clsx';
import { Paper, Box, Typography } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { Empty, Button } from 'components';
import ImagePlaceholder from 'assets/img/placeholder/empty-state.svg';

import classes from './EmptyState.module.scss';

const EmptyState = ({ isActive = true, isFocused = false, onClick }) => {
  return (
    <Paper className={clsx(classes.emptyState, { [classes.isInactive]: !isActive })}>
      {isFocused ? (
        <Box className={classes.focusedState}>
          <CloudUploadIcon />
          <span>Drop your files to upload</span>
        </Box>
      ) : (
        <Empty
          image={ImagePlaceholder}
          title='More than just storing files'
          subTitle={`Collect documents from your business partners and receive an alert to renew your compliance documents on time for shipment.`}>
          <Button
            disabled={!isActive}
            className={classes.button}
            classes={{
              disabled: classes.buttonDisabled,
            }}
            variant='contained'
            color='primary'
            onClick={(event) => {
              event.stopPropagation();
              onClick();
            }}>
            Browser files
          </Button>
          {isActive ? (
            <Box mt={2.5}>
              <Typography className={classes.caption}>or drop your files here</Typography>
            </Box>
          ) : null}
        </Empty>
      )}
    </Paper>
  );
};

export default EmptyState;
